module.exports = __webpack_public_path__ + "img/photo-0084.80f8bf76.jpg";